import { ROUTES } from '@/constants/constants';
import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { Box } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function LegalInfo() {
  const { t, i18n } = useTranslation('web', { keyPrefix: 'components.AuthModal' });
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);

  const handleClose = () => dispatch({ type: AppStateActions.SET_AUTH_STATE, payload: { state: undefined } });

  return (
    <Box sx={{ color: 'text.secondary' }} fontSize={'14px'} textAlign={'center'}>
      <span>
        {t('agreement', { action: authState.state === 'SIGN_IN' ? t('signingIn') : t('creatingAccount') })}{' '}
        <Link onClick={handleClose} to={ROUTES.terms(i18n.language)}>
          <Box sx={{ color: 'primary.main' }} display={'inline'}>
            {t('terms')}
          </Box>
        </Link>
        , {t('andOur')}{' '}
        <Link onClick={handleClose} to={ROUTES.policy(i18n.language)}>
          <Box sx={{ color: 'primary.main' }} display={'inline'}>
            {t('privacyPolicy')}
          </Box>
        </Link>
      </span>
    </Box>
  );
}

export { LegalInfo };
